export const digiQRoles = [
    {label: "Student", value: "student"},
    {label: "Teacher", value: "teacher"},
    {label: "University Representative", value: "uniRepresentative"},
]